<div>
  <h1 class="text-2xl font-bold text-gray-900 dark:text-white mb-1">
    <span *ngIf="!currentPageInfo().icon">
      <img src="{{ themeService.currentTheme() === 'dark' ? '/logos/wsy-green-yellow.png' : '/logos/wsy-yardBull-Icon.png' }}" alt="Menu" class="h-8 w-8 drop-shadow-sm inline-block mr-2 align-middle" /> {{ currentPageInfo().title }}
    </span>
    <span *ngIf="currentPageInfo().icon">
      <i class="fas inline-block mr-2 align-middle" [class]="currentPageInfo().icon"></i> {{ currentPageInfo().title }}
    </span>
  </h1>
  <p class="text-gray-600 dark:text-gray-400 text-sm">
    {{ currentPageInfo().subtitle }}
  </p>
</div>
